/**
 * @fileoverview
 * Lazy loaded Markdown component providing a markdown -> html conversion
 * of string input
 */
import { forwardRef, Fragment, lazy, memo, Suspense } from 'react'

import { chunk } from './chunk'
import type { IProps } from './types'

const Component = memo(lazy(chunk))

export const Markdown = forwardRef<HTMLDivElement, IProps>((props, ref) => (
  <Suspense fallback={<Fragment />}>
    <Component ref={ref} {...props} />
  </Suspense>
))
